import React, { useState, useEffect } from 'react';
import Header from './components/Header';
import Overview from './components/Overview';
import NameNumerology from './components/NameNumerology';
import LoveCompatibility from './components/LoveCompatibility';
import UserManagement from './components/UserManagement';
import OrderValidation from './components/OrderValidation';
import Login from './components/Login';
import { getStoredToken, getStoredUser, removeStoredToken, removeStoredUser } from './services/auth';
import { User } from './services/auth';

function App() {
  const [activeTab, setActiveTab] = useState('overview');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState<User | null>(null);

  useEffect(() => {
    const token = getStoredToken();
    const storedUser = getStoredUser();
    
    if (token && storedUser) {
      setIsAuthenticated(true);
      setUser(storedUser);
    }
  }, []);

  const handleLoginSuccess = (user: User) => {
    setIsAuthenticated(true);
    setUser(user);
  };

  const handleLogout = () => {
    removeStoredToken();
    removeStoredUser();
    setIsAuthenticated(false);
    setUser(null);
    setActiveTab('overview');
  };

  const handleShowUserManagement = () => {
    setActiveTab('user-management');
  };

  const handleShowChangePassword = () => {
    // This will be handled by the UserManagement component
    setActiveTab('user-management');
  };

  const renderContent = () => {
    switch (activeTab) {
      case 'overview':
        return <Overview />;
      case 'numerology':
        return <NameNumerology />;
      case 'compatibility':
        return <LoveCompatibility />;
      case 'order-validation':
        return <OrderValidation />;
      case 'user-management':
        return <UserManagement currentUser={user!} />;
      default:
        return <Overview />;
    }
  };

  if (!isAuthenticated) {
    return <Login onLoginSuccess={handleLoginSuccess} />;
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Header 
        activeTab={activeTab} 
        onTabChange={setActiveTab} 
        onLogout={handleLogout} 
        user={user}
        onShowUserManagement={handleShowUserManagement}
        onShowChangePassword={handleShowChangePassword}
      />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {renderContent()}
      </main>
    </div>
  );
}

export default App;
